<template>
	<div class="scene-wrapper">
		<ReviewHeading />
		<div class="round-results-wrapper">
			<div class="earnings-wrapper">
				<div class="earnings">{{ formattedEarnings }}</div>
				<div class="earnings-label">Show earnings</div>
			</div>
			<ul class="meter-wrapper">
				<Meter
					class="meter alt-color"
					v-for="score in scores"
					:key="score.id"
					v-bind="score"
				/>
			</ul>
			<ul class="meter-summaries">
				<li
					class="summary"
					v-for="meter in meterReportTexts"
					:key="`meter-${meter.id}`"
				>
					<ChangeIndicator class="change-indicator" :meterChange="meter.change"/>
					<span class="meter-title">{{ meter.title }}:</span>
					{{ meter.report }}
				</li>
			</ul>
			<svg viewBox="0 0 80.05 59.25" xmlns="http://www.w3.org/2000/svg" v-bind:class="'vegas-fund-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.01 38.33l33.7-18.74 32.78 18.74-33.24 18.75z" fill="#ad7330"/><path d="M73.43 38.32l-1.74-1-4.47-2.4-9.28-5.17-9.46-5.36-4.71-2.7-2.33-1.34-1.15-.67-.51-.3-.29-.17c-.22.08-1.1.5-1.75.8C18.85 28.82 1.39 38.12 1.39 38.12c-1.61.79-1.92 0-.39-.77 0 0 17.61-8.66 35.93-18.57l2.58-1.38 19.71 10.02 9.43 4.88 4.57 2.37 6.87 3.67L73.15 42l-4.56 2.36-9.56 4.88-20 10c-.77-.41-1.48-.79-2.18-1.18C18.56 48.07 1 39.32 1 39.32c-1.54-.82-1.22-1.57.39-.77 0 0 17.41 9.42 36.25 18.3l.84.39.52.23.29-.18.52-.3 1.17-.66 2.36-1.35 4.77-2.7 9.59-5.36 9.41-5.18 4.53-2.45 1.79-1z" fill="#211810"/><path d="M10.88 12.36S21.42 12.19 21.42 0c0 12.36 10.38 12.36 10.38 12.36S20.88 15 21.22 28c.66-14-10.34-15.64-10.34-15.64z" fill="#211810"/><path d="M11.5 12.27s.4.09 1.19.36a13.56 13.56 0 013.3 1.76 12.77 12.77 0 014 4.85 18.31 18.31 0 011.58 8.77h-.65A18.6 18.6 0 0122 20.88a14.7 14.7 0 017.38-8 12.82 12.82 0 012.32-.89l.09.81a11 11 0 01-3-.56 10.92 10.92 0 01-2.73-1.31 10.2 10.2 0 01-3.64-4.24A15.67 15.67 0 0121.12 0h.61a13.9 13.9 0 01-2.13 7.82 10.44 10.44 0 01-4.17 3.59 12.89 12.89 0 01-3 1 9.64 9.64 0 01-1 .14c-.83.07-.79-.35 0-.42 0 0 .3 0 .93-.16a12.28 12.28 0 002.85-1 9.85 9.85 0 003.94-3.45 13.41 13.41 0 002-7.52h.61a16 16 0 001.36 6.37 9.49 9.49 0 003.37 3.86 10.81 10.81 0 005.34 1.71l.1.82a12.33 12.33 0 00-2.15.84 14.06 14.06 0 00-7 7.55 19.06 19.06 0 00-1.15 6.84h-.64a17.85 17.85 0 00-1.45-8.51 12.37 12.37 0 00-3.85-4.66 13.36 13.36 0 00-3.16-1.74 11.83 11.83 0 00-1.13-.36c-.74-.24-.69-.59.1-.45z" fill="#211810"/><path d="M15.64 6.66s5.79 5.62 12.38-1c-6.68 6.68-1.07 12.3-1.07 12.3s-6.95-4.46-12.29.89c5.34-5.15.98-12.19.98-12.19z" fill="#211810"/><path d="M16.03 6.92s.12.21.33.67a12.27 12.27 0 01.8 2.17 10.78 10.78 0 01.36 4 9 9 0 01-2.65 5.29l-.43-.44a13.4 13.4 0 011.23-1.08 8.82 8.82 0 012.77-1.37 9.65 9.65 0 013.9-.25 10.81 10.81 0 012 .44c.34.1.66.23 1 .34l.22.1-.13-.23a9.05 9.05 0 01-.45-.94 8.25 8.25 0 01-.56-2 7.73 7.73 0 01.47-3.95 12.1 12.1 0 012.9-4.2l.44.45a10.67 10.67 0 01-5.29 3.06 8 8 0 01-4.26-.27 9.46 9.46 0 01-2.22-1.12 6.28 6.28 0 01-.65-.48c-.44-.39-.13-.66.27-.33a7 7 0 00.62.44 8.93 8.93 0 002.14 1 7.41 7.41 0 004 .2 10.23 10.23 0 005-3l.44.45c-.82.95-5.92 5.95-1.06 11.81 0 .05-.1.13-.17.22l-.08.1-.27.32c-.32-.17-.67-.38-1-.51l-.46-.21-.24-.1c-.3-.11-.61-.24-.92-.33a11.35 11.35 0 00-1.9-.43 8.86 8.86 0 00-3.59.19 8 8 0 00-2.57 1.2c-.61.44-1 .83-1.19 1l-.43-.44a8.41 8.41 0 002.53-4.9 10.67 10.67 0 00-.29-3.85 13.65 13.65 0 00-.68-2.12c-.2-.44-.31-.64-.31-.64-.22-.54.08-.74.38-.26z" fill="#211810"/><circle cx="4.01" cy="35.83" fill="#211810" r="3.75"/><circle cx="15.26" cy="35.83" fill="#211810" r="3.75"/><circle cx="25.26" cy="35.83" fill="#211810" r="3.75"/><circle cx="36.5" cy="35.83" fill="#211810" r="3.75"/><circle cx="46.5" cy="35.83" fill="#211810" r="3.75"/><circle cx="57.75" cy="35.83" fill="#211810" r="3.75"/><circle cx="67.74" cy="35.83" fill="#211810" r="3.75"/><g fill="#ad7330"><circle cx="7.76" cy="32.08" r="3.75"/><circle cx="19.01" cy="32.08" r="3.75"/><circle cx="29" cy="32.08" r="3.75"/><circle cx="40.25" cy="32.08" r="3.75"/><circle cx="50.25" cy="32.08" r="3.75"/><circle cx="61.5" cy="32.08" r="3.75"/><circle cx="71.49" cy="32.08" r="3.75"/></g><path d="M7.89 35.17a2.83 2.83 0 001-.19 3.35 3.35 0 001.87-1.65 3.16 3.16 0 00-.1-3 3.09 3.09 0 00-5-.48 3.15 3.15 0 00-.6 2.97 3.35 3.35 0 001.51 2 3.06 3.06 0 001 .39c.2.06.13 1.19-.17 1.19a2.22 2.22 0 01-.39 0 4.61 4.61 0 01-1-.31 4.72 4.72 0 01-2.56-2.63 5 5 0 01.65-4.79 5 5 0 014.5-2 5 5 0 014 2.82 5 5 0 01-.28 4.83 4.79 4.79 0 01-3 2.09 4.7 4.7 0 01-1.08.1 1.88 1.88 0 01-.38 0c-.33-.27-.18-1.27.03-1.34zM22.12 31.57a3 3 0 00-.3-1A3.28 3.28 0 0020 28.82a3.14 3.14 0 00-2.94.38 3.09 3.09 0 000 5 3.14 3.14 0 002.94.39 3.32 3.32 0 001.82-1.7 3 3 0 00.3-1c0-.21 1.17-.25 1.19.06a1.64 1.64 0 010 .39 4.27 4.27 0 01-.2 1.06 4.78 4.78 0 01-2.37 2.79 5 5 0 01-4.84-.18 5.18 5.18 0 01-1.8-1.89 5 5 0 010-4.79 5.18 5.18 0 011.8-1.89 5 5 0 014.84-.18 4.77 4.77 0 012.37 2.8 4.12 4.12 0 01.2 1.06 1.56 1.56 0 010 .38c-.09.32-1.09.32-1.19.07zM32.09 29.71a3.1 3.1 0 00-.81-.69 3.33 3.33 0 00-2.45-.42 3.1 3.1 0 00-1.95 4.72 3.09 3.09 0 005.1.1 3.26 3.26 0 00.6-2.41 3.11 3.11 0 00-.31-1c-.08-.2.84-.85 1-.6a1.83 1.83 0 01.21.32 5.15 5.15 0 01.41 1 4.78 4.78 0 01-.46 3.64 5 5 0 01-4.11 2.45 5.21 5.21 0 01-2.55-.6 5 5 0 01-2.62-4 5 5 0 014.42-5.37 4.79 4.79 0 013.52 1.05 5.14 5.14 0 01.75.77 2.06 2.06 0 01.22.32c.08.34-.79.83-.97.72zM43.36 31.57a3.12 3.12 0 00-.29-1 3.34 3.34 0 00-1.85-1.75 3.15 3.15 0 00-3 .38 3.1 3.1 0 000 5 3.16 3.16 0 003 .39 3.39 3.39 0 001.82-1.7 3.12 3.12 0 00.29-1c0-.21 1.17-.25 1.2.06a2.86 2.86 0 010 .39 4.68 4.68 0 01-2.57 3.85 5 5 0 110-8.93 4.77 4.77 0 012.37 2.8 4.61 4.61 0 01.2 1.06 2.72 2.72 0 010 .38c-.08.32-1.08.32-1.17.07zM52.92 34.23a3.21 3.21 0 00.58-.89 3.34 3.34 0 00.09-2.52 3.13 3.13 0 00-2.21-2 3.1 3.1 0 00-3.79 3.26 3.19 3.19 0 001.63 2.54 3.31 3.31 0 002.47.27 3 3 0 001-.44c.18-.11.95.72.73.94a2 2 0 01-.3.25 4.27 4.27 0 01-.93.53 4.76 4.76 0 01-3.67 0 5 5 0 01-3-3.79 5.1 5.1 0 01.26-2.6 5 5 0 019.53.55 4.83 4.83 0 01-.57 3.63 5 5 0 01-.67.84 2.78 2.78 0 01-.29.26c-.35.17-.96-.63-.86-.83zM73.65 34.23a3 3 0 00.58-.89 3.29 3.29 0 00.1-2.48 3.13 3.13 0 00-2.21-2 3.1 3.1 0 00-3.79 3.26 3.17 3.17 0 001.63 2.48 3.34 3.34 0 002.48.27 3 3 0 001-.44c.19-.11 1 .72.74.94a2 2 0 01-.3.25 4.53 4.53 0 01-.93.53 4.76 4.76 0 01-3.67 0 5 5 0 01-3-3.79 5 5 0 011.61-4.54 5 5 0 018.12 2.58 4.83 4.83 0 01-.57 3.63 4.48 4.48 0 01-.68.84 2.3 2.3 0 01-.28.26c-.26.1-.92-.7-.83-.9zM62.62 28.61a3.25 3.25 0 00-1-.21 3.38 3.38 0 00-2.4.82 3.18 3.18 0 00-1 2.79 3.09 3.09 0 006.13-.1 3.33 3.33 0 00-.65-2.4 2.88 2.88 0 00-.77-.74c-.16-.13.33-1.15.61-1a2 2 0 01.34.19 4.31 4.31 0 01.84.67 4.76 4.76 0 011.38 3.4 5 5 0 01-2.42 4.2 5 5 0 01-6.75-1.52 5 5 0 011.29-6.89 4.82 4.82 0 013.58-.8 4.36 4.36 0 011 .32 3.68 3.68 0 01.35.17c.21.31-.31 1.12-.53 1.1z" fill="#ece8c1"/></svg>
			<span class="vegas-fund-summary">You've saved
				<span class="fund-amount">{{ currentSavings }}</span>
				of your
				<span class="fund-amount">{{ savingsTarget }}</span>
				Vegas goal.
			</span>
		</div>
		<Button class="review-btn" :action="set">Continue</Button>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { currencyFormatter } from "@/lib/formatters";
import Button from '@/components/base/Button';
import Meter from '@/components/game/sidebar/Meter';
import ChangeIndicator from '@/components/game/review/ChangeIndicator';
import ReviewHeading from '@/components/game/review/ReviewHeading';

export default {
	name: 'Review',
	components: {
		Button,
		Meter,
		ChangeIndicator,
		ReviewHeading,
	},
	data() {
		return {
			activeSlot: null,
			test: 'decreased',
		};
	},
	computed: {
		...mapGetters({
			scores: "game/scores/list",
			funds: "game/funds/list",
			meterReportTexts: "game/reviews/meterReportText",
		}),
		...mapState("game/balance", {
			earnings: (state) => state.amount,
		}),
		formattedEarnings() {
			return currencyFormatter.format(this.earnings);
		},
		currentSavings() {
			return currencyFormatter.format(this.$store.state.game.funds[210].balance);
		},
		savingsTarget() {
			return currencyFormatter.format(this.$store.state.game.funds[210].minimum_winning_balance);
		},
	},
	methods: {
		set() {
			this.$router.push('/game/travel');
			this.$store.dispatch("sound/fx/play", { id: "button_affirmative" });
			this.$store.dispatch("sound/fade", {
				id: "audience_murmur",
				volume: 0,
				duration: 1000,
			});
		},
		playSoundFx() {
			this.$store.dispatch("sound/fx/play", { id: "newspaper" });
			this.$store.dispatch("sound/fx/play", { id: "audience_murmur" });
		},
	},
	mounted() {
		this.playSoundFx();
	},
};
</script>

<style lang="scss" scoped>
	.scene-wrapper {
		height: 100%;
		overflow-y: scroll;
		display: block;
	}

	.round-results-wrapper {
		background: $off-white-dark;
		border-radius: 5px;
		margin: 5% auto;
		padding: 3% 5%;
		width: 65vw;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		@include mobile { padding: 5% 10%; }
		@include tablet { padding: 2% 8%; }
		@include desktop { width: 800px; }
	}

	.meter-wrapper {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: flex-end;
		font-family: $body-font-alt-bold;
		font-size: $font-size-base;
		text-transform: uppercase;
		margin-bottom: 2em;

		@include mobile { font-size: $font-size-sm; }
		@include tablet { width: 85%; }
	}

	.meter-summaries {
		display: flex;
		flex-direction: column-reverse;
		margin-bottom: 1em;
	}

	.meter.alt-color {
		margin: 0 5%;

		& /deep/ .meter-icon { padding: 10%;}
	}

	.earnings-wrapper { margin: 1em 0; }

	.earnings {
		font-size: $heading-size-base;
		line-height: 1;

		@include tablet { font-size: $heading-size-lg; }
		@include desktop { font-size: $heading-size-lg; }
	}

	.change-indicator {
		margin: auto 0;
		width: 1rem;
		transform: translate(-120%);
		padding: 3px;
		margin: auto 0;
	}

	.earnings-label,
	.meter-title {
		text-align: center;
		font-family: $body-font-alt-bold;
		font-size: $font-size-base;
		text-transform: uppercase;
		position: relative;
		font-size: $font-size-base;

		@include mobile { font-size: $font-size-sm; }
	}

	.summary {
		position: relative;
		margin-bottom: 1em;
		font-family: $body-font-alt;
		font-size: $font-size-base;

		@include mobile { font-size: $font-size-sm; }
	}

	.vegas-fund-icon {
		width: 100px;
		margin-bottom: 1em;
	}

	.vegas-fund-summary {
		font-family: $body-font-alt-bold;
		font-size: $font-size-base;
		margin-bottom: 1em;
	}

	.fund-amount { color: $primary-color-dark; }
	.review-btn { margin: 0 auto 5%; }
</style>



// WEBPACK FOOTER //
// src/components/game/scenes/Review.vue